<template>
  <div class="tenantDetail">
    <div class="intro-y box overflow-hidden mt-5 asset-page-title clearfix">
      <div class="top-l" @click="goBack">
        < 返回
      </div>
      <template v-if="status == '1'">
        <h1>承租人详情</h1>
        <div class="sub-title">
          <img :src="broadside.imageUrl" alt="" v-if="broadside">
          <span>{{businessName}}</span>
        </div>
      </template>
      <template v-if="status == '0'">
        <h1>租客详情</h1>
        <div class="sub-title">
          <span>{{lessee}}</span>
        </div>
      </template>
      
      <div class="tabs">
        <el-tabs v-model="activeKey" @tab-click="changeHandle" class="istop">
          <el-tab-pane label="企业信息" name="1" v-if="status == '1'"></el-tab-pane>
          <el-tab-pane label="个人信息" name="2" v-if="status == '0'"></el-tab-pane>
          <el-tab-pane label="租赁情况" name="3"></el-tab-pane>
        </el-tabs>
        <div v-if="status == '0' && activeKey == '2' && flag" @click="editUser" class="btn-mr">
          编辑个人信息
        </div>
      </div>
      
    </div>
    <div>
      <creditor-info ref="first" v-if="activeKey==='1'"></creditor-info>
      <user-news v-if="activeKey==='2'"></user-news>
      <leasing v-if="activeKey==='3'"></leasing>
    </div>
  </div>
</template>

<script>
  import creditorInfo from './components/creditorInfo.vue'
  import userNews from './components/userNews.vue'
  import leasing from './components/leasing.vue'
  import {getBusinessInfo} from '../../api/tenant'
  import {mapState} from 'vuex'
  export default {
    name: "tenantDetail",
    components: {
      creditorInfo,
      userNews,
      leasing
    },
    data() {
      return {
        status:1,
        activeKey:'1',
        broadside:{
          imageUrl:''
        },
        businessName:'',
      }
    },
    methods: {
      goBack(){
        this.$router.push('/tenantManagement/tenantList')
      },
      editUser(){
        this.$store.commit('GET_FLAG', false)
      },
      changeHandle(val){
        
      },
      getMort(){
        let para = {
          keyWord: this.businessName
        }
        getBusinessInfo(para).then(res => {
          let data = res.data;
          if (data.code === '000') {
            this.broadside = data.content
          }else {

          }
        }).catch(err => {
          console.log(err);
        })
      }
    },
    created() {
      this.status =  this.$route.query.status
      if(this.status == 0) {
        this.activeKey = '2'
      }else{
        this.activeKey = '1'
        this.businessName = this.$route.query.broadside
        this.getMort()
      }
    },
    computed:{
      ...mapState({
        lessee:state=>state.work.lessee,
        flag:state=>state.work.flag
      }),
    }
  }
</script>

<style scoped lang="scss">
  .tenantDetail {
    min-height: calc(100vh - 84px);
    .header {
      background: #fff;
      color: red;
    }
    .asset-page-title{
      padding:0 24px;
      .top-l {
        font-size: 18px;
        color: #40a9ff;
        line-height: 58px;
        cursor: pointer;
      }
      .sub-title{
        margin:20px 0;
        img{
            width:70px;
            height:70px;
            display:inline-block;
            margin-right: 18px;
            vertical-align: middle;
        }
        span{
            font-size: 18px;
            vertical-align: middle;
        }
      }
      .tabs{
        display: flex;
        justify-content: space-between;
        .istop{
          width: 100%;
        }
        .btn-mr {
          display: inline-block;
          height: 40px;
          width: 140px;
          line-height: 40px;
          cursor: pointer;
          color: #FFF;
          background-color: #409EFF;
          border: 1px solid #409EFF;
          -webkit-appearance: none;
          text-align: center;
          box-sizing: border-box;
          outline: 0;
          margin: 0;
          transition: .1s;
          font-weight: 500;
          font-size: 14px;
          padding: 0 20px;
          border-radius: 4px;
        }
      }
    }
  }
</style>
